package org.hs_soft.runmynesto.domain.usecase.home

import org.hs_soft.runmynesto.domain.model.home.home.global_search.GlobalSearchModel
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.CheckoutModel
import org.hs_soft.runmynesto.domain.repository.local_datasource.home.SaveCheckOutRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.home.GlobalSearchRepository

class GlobalSearchUseCase(
    private val repository: GlobalSearchRepository
) {
    suspend operator fun invoke(searchValue:String):GlobalSearchModel {
        return repository.getGlobalSearchData(searchValue)
    }
}